<template>
  <v-card outlined class="rounded-lg">
    <v-card-title>Kontakte {{ status }}</v-card-title>
    <v-card-text class="pa-0">
      <div class="body-2 pa-4" v-if="bbrbbr.length === 0">Kein {{ status }} eingetragen</div>
      <v-simple-table dense fixed-header>
        <tbody>
          <tr v-for="item in bbrbbr" :key="item.id" v-on:dblclick="(bbr = item) && (showKontakt = true)">
            <td>{{ item.nachname }}, {{ item.vorname }}</td>
            <td width="20px" v-on:click="(bbr = item) && (showKontakt = true)"><v-icon>info</v-icon></td>
          </tr>
        </tbody>
      </v-simple-table>

      <dialogKontakt :visible.sync="showKontakt" :bbr="bbr" @close="showKontakt = false"></dialogKontakt>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    props: ['status'],
    data () {
      return {
        bbr: {},
        showKontakt: false
      }
    },
    computed: {
      bbrbbr () {
        return this.$store.getters['bbrbbr/bbrStatus'](this.status)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// kontakteStatus.vue?69040eb3